import ctl from '@netlify/classnames-template-literals';

export const buttonStyle = ctl(`
  px-8
  py-2
  mt-4
  rounded-sm
  bg-green-ncs
  text-anti-flash-white
`);

export const buttonClasses = {
  container: 'rounded-sm bg-transparent',
  text: 'text-waterspout',
};

export const buttonsContainerStyle = ctl(`
  self-end
  space-x-2
`);

export const sectionStyle = ctl(`
  grid
  gap-x-4
  gap-y-2
  grid-cols-2
`);

export const formStyle = ctl(`
  flex
  flex-col
  w-full
`);
